<template>
  <div>
    <!-- 悬浮菜单开始 -->
    <div class='realTranslationInfos' v-drag>
      <div class='RealtranslationBox'>
        <div class='popupTitle'>
          欢迎来到埃文官网
        </div>
        <div class='consultationContent'>
          <ul >
            <li v-for='item in dataList' :key='item.id' >
              <a @click='doctor(item)'>{{ item.name }}</a>
            </li>

          </ul>
        </div>
        <div class='submit'>
          <p>{{ answer }}</p>
        </div>
      </div>
    </div>
    <!-- 悬浮菜单结束 -->
  </div>
</template>
<script>
import { selectProblem } from '@api/auth'

export default {
  // 组件名字
  name: 'FeedBack',
  // 组件参数
  props: {
    id: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    }
  },
  created () {
    this.selectProblem()
  },
  data () {
    return {
      dataList: [],
      answer: '',
      queryParams: {
      }
    }
  },
  mounted () {
  },
  // 组件方法
  methods: {
    openFeedbackDialog () {
    },
    /** 问题列表 */
    selectProblem () {
      let that = this
      selectProblem(this.queryParams).then(res => {
        that.dataList = res
      })
    },
    doctor (raw) {
      this.answer = raw.answer
    }
  }
}
</script>
<style scoped='scoped' lang='scss'>
.realTranslationInfos {
  width: 66px;
  height: 66px;
  // background: red;
  position: fixed;
  // position: absolute;
  bottom: 56px;
  right: 20px;
  z-index: 99999;
  // bottom: 122px;
  // right: -30px;
  .translationContent {
    min-height: 100px;
    line-height: 23px;
    width: 338px;
    padding: 18px 74px 19px 19px;
    background: #004CB3;
    opacity: 0.80;
    border-radius: 12px;
    color: #fff;
    position: fixed;
    // position: absolute;
    right: 58px;
    bottom: 22px;
    z-index: 99999;
  }

  .RealtranslationBox {
    width: 280px;
    height: 320px;
    position: absolute;
    padding: 10px;
    right: 2px;
    bottom:2px;
    z-index: 999;
    border-radius: 10px;
    background-color: #6ac13a;
    .popupTitle{
      height: 30px;
      line-height: 30px;
      text-align: center;
      margin-bottom: 10px;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
   }
    .consultationContent{
      background-color:rgba(255,255,255,.6);
      border-radius: 5px;
      z-index: 99999;
      ul{
        min-height: 180px;
        padding-bottom: 10px;
        li{
          height: 30px;
          line-height: 30px;
          text-indent:8px;
          color: #2f54eb;
        }
      }
    }
    .submit{
      height: 60px;
      margin: 5px 0;
      padding:8px;
      border-radius: 5px;
      background-color:rgba(255,255,255,.9);
    }
  }
}
</style>
